// extracted by mini-css-extract-plugin
export default {"root":"IconSpinner_root__6JFKA","spin":"IconSpinner_spin__5D16g"};